import CookieConsentHelper from './cookie_consent_helper'

let gleapPromise = null
let widgetWasInDom = false
let currentLanguage = null

up.compiler('.unpoly_wrapper:not(.js-no_gleap)', function (element) {
  const data = element.dataset.gleap && JSON.parse(element.dataset.gleap)

  if (data && data.enabled) {
    CookieConsentHelper.warnOrRunWhenConsentGiven(['preferences'], () => applyConfig(data))
  }
})

up.compiler('.js-clear_gleap_identity', function (element) {
  element.addEventListener('click', clearIdentity)
})

// Gleap.initialize must only be called once; later compiler runs (Unpoly
// fragment swaps) reuse the loaded instance and only update identity/launcher.
function loadGleap(apiKey) {
  if (!gleapPromise) {
    gleapPromise = import(/* webpackChunkName: "gleap" */ 'gleap').then(({ default: Gleap }) => {
      // The npm build sets no global; expose it for debugging and integration tests.
      window.Gleap = Gleap
      // Before initialize, setLanguage only stores the override; afterwards
      // every call rebuilds the whole widget (closing an open chat).
      currentLanguage = document.documentElement.lang
      Gleap.setLanguage(currentLanguage)
      Gleap.initialize(apiKey)
      return Gleap
    })
  }

  return gleapPromise
}

async function applyConfig(data) {
  const Gleap = await loadGleap(data.api_key)

  // Unpoly normally swaps only .unpoly_wrapper, but a fallback render can
  // replace the whole body and destroy Gleap's container. The container is
  // injected async after initialize, so only a disappearance counts.
  const widgetInDom = !!document.querySelector('.gleap-frame-container')

  if (widgetWasInDom && !widgetInDom) {
    Gleap.getInstance().softReInitialize()
  }

  // plain assignment also resets during the async rebuild, so compiler runs
  // in that window don't restart it again
  widgetWasInDom = widgetInDom

  const language = document.documentElement.lang

  if (language !== currentLanguage) {
    currentLanguage = language
    Gleap.setLanguage(language)
  }

  if (data.user_id) {
    const contact = {
      name: data.name,
      email: data.email,
      createdAt: new Date(data.created_at * 1000)
    }

    if (data.company) contact.company = data.company

    Gleap.identify(data.user_id, contact, data.user_hash)
  } else if (Gleap.isUserIdentified()) {
    Gleap.clearIdentity()
  }

  Gleap.showFeedbackButton(!data.hide_launcher)
}

async function clearIdentity() {
  if (!gleapPromise) return

  const Gleap = await gleapPromise
  Gleap.clearIdentity()
}
